import * as React from 'react';

interface TrophyIconProps {
    className?: string;
    isFirst?: boolean;
}

export const TrophyIcon: React.FC<TrophyIconProps> = ({ className, isFirst = false }) => {
    const mainColor = isFirst ? "#FFD700" : "#C0C0C0"; // Gold for first place, Silver for others
    
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            {/* Purple glow filter */}
            <defs>
                <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
                    <feGaussianBlur stdDeviation="2" result="blur" />
                    <feComposite in="SourceGraphic" in2="blur" operator="over" />
                </filter>
            </defs>
            
            {/* Trophy body */}
            <path 
                d="M30 10H28V8C28 6.9 27.1 6 26 6H14C12.9 6 12 6.9 12 8V10H10C8.9 10 8 10.9 8 12V14C8 17.31 10.69 20 14 20H15.26C16.53 21.81 18.62 23 21 23H19V26H14V30H26V26H21V23H19C21.38 23 23.47 21.81 24.74 20H26C29.31 20 32 17.31 32 14V12C32 10.9 31.1 10 30 10ZM14 17C12.34 17 11 15.66 11 14V13H14C14 14.71 14.56 16.26 15.5 17.5C15.05 17.27 14.54 17 14 17ZM29 14C29 15.66 27.66 17 26 17C25.46 17 24.95 17.27 24.5 17.5C25.44 16.26 26 14.71 26 13H29V14Z" 
                fill={mainColor}
                filter="url(#glow)"
            />
            
            {/* Purple outline */}
            <path 
                d="M30 10H28V8C28 6.9 27.1 6 26 6H14C12.9 6 12 6.9 12 8V10H10C8.9 10 8 10.9 8 12V14C8 17.31 10.69 20 14 20H15.26C16.53 21.81 18.62 23 21 23H19V26H14V30H26V26H21V23H19C21.38 23 23.47 21.81 24.74 20H26C29.31 20 32 17.31 32 14V12C32 10.9 31.1 10 30 10ZM14 17C12.34 17 11 15.66 11 14V13H14C14 14.71 14.56 16.26 15.5 17.5C15.05 17.27 14.54 17 14 17ZM29 14C29 15.66 27.66 17 26 17C25.46 17 24.95 17.27 24.5 17.5C25.44 16.26 26 14.71 26 13H29V14Z" 
                stroke="#8E59FF"
                strokeWidth="1.5"
                fill="none"
            />
        </svg>
    );
}; 